module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.communityMissions) ? _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "16%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.startTime')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "44%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.title')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.creator')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.communityMissions), function(communityMission) {
    return _c('community-missions-row', {
      key: communityMission.uid,
      attrs: {
        "communityMission": communityMission
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.communityMissions.length >= 10),
      expression: "communityMissions.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "16%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.startTime')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "44%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.title')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.creator')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1e2e86c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communities/CommunityMissionsTable.vue
// module id = 573
// module chunks = 0